/**
 * The built-in date format options.
 */
export var DateFormat;
(function (DateFormat) {
    /**
     * Format used to create ISO date strings (e.g. "1973-04-15T23:55:00.123Z").
     */
    DateFormat["ISO"] = "ISO";
    /**
     * Format used to create long date strings (e.g. "15 April 1973").
     */
    DateFormat["DateLong"] = "DateLong";
    /**
     * Format used to create short date strings (e.g. "15/04/1973").
     */
    DateFormat["DateShort"] = "DateShort";
    /**
     * Date format to be used when you do not specify a long or short format.
     */
    DateFormat["DateDefault"] = "DateDefault";
    /**
     * Format used to create long time strings (e.g. "13:55:01").
     */
    DateFormat["TimeLong"] = "TimeLong";
    /**
     * Format used to create short time strings (e.g. "13:55").
     */
    DateFormat["TimeShort"] = "TimeShort";
    /**
     * Time format to be used when you do not specify a long or short format.
     */
    DateFormat["TimeDefault"] = "TimeDefault";
})(DateFormat || (DateFormat = {}));
//# sourceMappingURL=date-format-options.js.map